import type { TenantInfo, UserTenantsResponse } from '@/lib/api/types';

/**
 * The tenant the current access token is scoped to, or null.
 *
 * `/auth/tenants` is the only place the frontend learns this: `/auth/me`
 * returns the user without a tenant, and making it tenant-aware would lock out
 * users who have no tenancy yet — the no-tenant onboarding dialog depends on it
 * answering.
 *
 * Returns null rather than guessing. Falling back to `is_default` would report
 * the wrong workspace for anyone who has switched tenants, which is exactly the
 * case worth getting right.
 */
export function selectActiveTenant(
  data: UserTenantsResponse | undefined
): TenantInfo | null {
  if (!data?.active_tenant_id) return null;

  return data.tenants.find((t) => t.id === data.active_tenant_id) ?? null;
}
